import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c6-six-three-three-two',
  templateUrl: './c6-six-three-three-two.component.html',
  styleUrls: ['./c6-six-three-three-two.component.scss']
})
export class C6SixThreeThreeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
